import { Button, Tooltip } from "@fluentui/react-components";
import { WeatherMoonRegular, WeatherSunnyRegular } from "@fluentui/react-icons";
import { useAtom, useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import { darkModeAtom, themePreferenceAtom } from "@/store";

/**
 * Toggles between light and dark mode. Clicking sets an explicit
 * preference (light or dark), overriding the 'system' default.
 * The Preferences dialog provides access to the full tri-state.
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  const isDark = useAtomValue(darkModeAtom);
  const [, setThemePreference] = useAtom(themePreferenceAtom);

  const toggle = () => {
    setThemePreference(isDark ? "light" : "dark");
  };

  return (
    <Tooltip
      content={isDark ? t("lightMode") : t("darkMode")}
      relationship="label"
    >
      <Button
        appearance="subtle"
        icon={isDark ? <WeatherSunnyRegular /> : <WeatherMoonRegular />}
        onClick={toggle}
        aria-label={isDark ? t("lightMode") : t("darkMode")}
      />
    </Tooltip>
  );
}
